module.exports = __webpack_public_path__ + "img/curved-rail-vertical-left-top-ties-remnants.eb9f675f.png";